import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, } from "react-router-dom"
import { ThemeProvider } from '@mui/material'
import Theme from './Theme'
import ScrollToTop from './commonHooks/ScrollToTop'
import { Provider } from "react-redux"
import store from "./redux/store"

import { ABBOTT_API_BASE_URL, ABBOTT_HEALTH_PATH } from './chess/domain/abbottApi'

// Wake up call to chess api
fetch(`${ABBOTT_API_BASE_URL}${ABBOTT_HEALTH_PATH}`, {
  method: 'GET',
  mode: 'cors',
  cache: 'no-store',
}).catch(() => {})

const theme = Theme();

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <ScrollToTop/>
          <App />
        </ThemeProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
